module.exports = ".box-document {\n  border: 1px solid #dee2e6;\n  border-radius: 5px;\n  padding: 7px;\n  width: 140px; }\n\n.ngx-datatable .datatable-body .datatable-row-detail {\n  overflow-y: hidden;\n  overflow-x: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/report-pending/report-pending.component.scss
// module id = ./src/app/pages/report-pending/report-pending.component.scss
// module chunks = main